import { useState } from "react";
import { Star, XStack, YStack } from "@medbillai/ui";
type Props = {
  rating?: number;
  onChangeRating: (rating: number) => void;
  disabled?: boolean;
};
export default function RatingStars({
  rating,
  onChangeRating,
  disabled = false
}: Props) {
  const [hoverRating, setHoverRating] = useState<number | null>(null);
  return <XStack gap="$2" data-sentry-element="XStack" data-sentry-component="RatingStars" data-sentry-source-file="RatingStars.tsx">
      {[1, 2, 3, 4, 5].map(star => <YStack key={star} onPress={() => onChangeRating(star)} hoverStyle={!disabled ? {
      scale: 1.1
    } : undefined} onMouseEnter={() => !rating && setHoverRating(star)} onMouseLeave={() => setHoverRating(null)} disabled={disabled}>
          <Star filled={star <= (hoverRating ?? rating ?? 0)} />
        </YStack>)}
    </XStack>;
}